import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";
import HubExternalListingAppResource from "./HubExternalListingAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";

class ExternalListingAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'External-Listing';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'externals/listings';
    }

    /**
     *
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'createdDate',
            'address',
            'address2',
            'city',
            'state',
            'listPrice',
            'listAgentFullName',
            'secondaryListAgentFullName',
            'onMarket',
            'status',
            'listingId',
            'moxiWorksOfficeId',
            'moxiWorksListingId',
            'agentUserUuid',
            'secondaryAgentUserUuid',
            'lookupIntegrationTypeUuid',
            'hubExternalListings',
            'organizationMembers',
        ];
    }

    /**
     * @returns {{user: UserAppResource, secondaryAgentUser: UserAppResource,}}
     */
    relationMap() {
        return {
            agentUser: UserAppResource,
            secondaryAgentUser: UserAppResource,
            hubExternalListings: HubExternalListingAppResource,
            organizationMembers: OrganizationMemberAppResource,
        }
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            agentUser: 'agent_user_uuid',
            secondaryAgentUser: 'secondary_agent_user_uuid',
        }
    }

    validationRules() {
        return {
            createdDate: {
                type: 'string',
                datetime: true,
            },
            address: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            address2: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            city: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            state: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            listPrice: {
                numericality: true,
            },
            listAgentFullName: {
                type: 'string',
            },
            secondaryListAgentFullName: {
                type: 'string',
            },
            propertyType: {
                type: 'string',
            },
            onMarket: {
                type: 'boolean',
            },
            listingId: {
                type: 'string',
            },
            status: {
                type: 'string',
            },
            moxiWorksOfficeId: {
                type: 'string',
            },
            moxiWorksListingId: {
                type: 'string',
            },
            agentUserUuid: {
                type: 'string',
            },
            secondaryAgentUserUuid: {
                type: 'string',
            },
            lookupIntegrationTypeUuid: {
                presence: true,
                type: 'string',
            },
        };
    }
}

export default ExternalListingAppResource;
